import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              福利分类导航
            </h2>
            <p className="text-sm text-foreground-500 max-w-xl mx-auto">
              按类别浏览您感兴趣的福利信息，快速定位最适合您的福利资源
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group p-6 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-200 hover:bg-background-50 transition-all duration-300 cursor-pointer"
              >
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors shrink-0">
                    <i className={`${cat.icon} text-xl`}></i>
                  </div>
                  <div className="min-w-0">
                    <h3 className="text-base font-semibold text-foreground-900 mb-1">
                      {cat.name}
                    </h3>
                    <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                      {cat.description}
                    </p>
                    <span className="inline-flex items-center gap-1 text-xs text-primary-600 font-medium">
                      {cat.articleCount} 篇内容
                      <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}